import React from 'react';

import styles from './Card.module.css';

import type { ReactNode } from 'react';

type Props = {
  children: ReactNode;
  className?: string;
};

export const Card = ({ className, children }: Props): React.ReactElement => (
  <article className={`${styles.root} ${className}`}>{children}</article>
);
